module.exports = __webpack_public_path__ + "img/Goin_5.c702eefe.jpg";